import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { loadValorReferencias, storeValorReferencia } from '~/store/modules/valor_referencia/action';
import { loadPorteEmpreendimentos } from '~/store/modules/porte_empreendimento/action';


const Create = () => {
  let history = useHistory();
  const [valorReferencia, setValorReferencia] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { tipo_licenca_id, atividade_id } = useParams();
  const { status_response, errors } = useSelector(({ ValorReferenciaReducer }) => ValorReferenciaReducer);

  useEffect(() => {
    dispatch(loadPorteEmpreendimentos())
  }, [dispatch]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.save) {
      setSaved(errors.save);
    }
  }, [errors]);

  useEffect(() => {
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadValorReferencias({
            where:`tipo_licenca_id:${tipo_licenca_id}`
          }));
        }
      );
    }
  }, [status_response, history, dispatch, saved, tipo_licenca_id]);

  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setErrorsValidate([]);
    if (!schema.isValidSync(valorReferencia)) {
      let yup_errors = {};
      schema.validate(valorReferencia, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const valueRef = valorReferencia;
      valueRef.atividade_id = parseInt(atividade_id);
      valueRef.porte_empreendimento_id = parseInt(valueRef.porte_empreendimento_id)
      valueRef.tipo_licenca_id = parseInt(tipo_licenca_id);
      // console.log('valor store: ', valueRef);
      await dispatch(storeValorReferencia(valorReferencia));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-md"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Valor de Referência
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              schema={schema}
              setValorReferencia={setValorReferencia}
              valorReferencia={valorReferencia}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_valor_referencia"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
